export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date First Played',
        category: ['User', 'Plays'],
        description: 'Date of the first play of the game.',
        summarise: {
            prefix: 'First played'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    }
}